<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.hangs'), $t('text.list')]"> </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <date-range
          v-model="searchForm"
          type="datetime"
          field="createAt"
          :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
        />
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.order.images" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.serialNo }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.order.productNo }}

            <div class="font10">{{ row.order.color }} {{ row.order.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.order.quantity }}{{ row.order.unit }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="hangSerialNo"
          :title="$t('hang.hangSerialNo')"
          min-width="130"
        />
        <vxe-table-column
          field="hangOrder.factoryName"
          :title="$t('menu.factories')"
          min-width="100"
        />

        <vxe-table-column
          field="hangOrder.handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.createName }}
            <div class="font10">{{ row.createAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="finishAt"
          :title="$t('hang.finishAt')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.finishName }}
            <div class="font10">{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          v-if="Permit.canActionsChargeEdition('mesHangFinish')"
          field="action"
          :title="$t('text.action')"
          width="60"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="row.finishAt == null"
              type="text"
              size="mini"
              @click="finish(row, rowIndex)"
              >{{ $t("action.deal") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 挂单 -->
    <el-dialog
      :title="$t('menu.workOrders')"
      :close-on-click-modal="false"
      :visible.sync="hangDF"
      width="70%"
    >
      <el-form ref="hangForm" :model="hangObj" label-width="80px">
        <el-row class="mgb15">
          <el-col :span="12">
            <el-form-item
              :label="$t('text.handOverAt')"
              :prop="'handOverAt'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.handOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="hangObj.handOverAt"
                type="date"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('text.remark')" :prop="'remark'">
              <el-input size="small" v-model="hangObj.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <vxe-table
          :data="hangWorkOrders"
          ref="workOrdersTable"
          size="mini"
          resizable
          round
          highlight-hover-row
          auto-resize
          @checkbox-change="checkboxChangeEvent"
          @checkbox-all="checkboxChangeEvent"
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="checkbox"
            type="checkbox"
            width="35"
          ></vxe-table-column>
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="85"
          >
            <template v-slot="{ row }">
              <thumbnail :images="row.images" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="serialNo"
            :title="$t('text.serialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              <small v-if="row.hurry" class="red">
                ({{ $t("order.hurrySimple") }})
              </small>
              <span v-if="row.workflowState != 'canceled'">
                <span
                  v-if="row.voidAt == null && row.jyOrderCancelAt == null"
                  >{{ row.serialNo }}</span
                >
                <s v-if="row.voidAt != null && row.jyOrderCancelAt == null">{{
                  row.serialNo
                }}</s>

                <s
                  v-if="row.voidAt == null && row.jyOrderCancelAt != null"
                  class="grey"
                  >{{ row.serialNo }}</s
                >
              </span>
              <span v-if="row.workflowState == 'canceled'" class="grey">
                {{ row.serialNo }}
              </span>

              <div class="font10">{{ row.orderInnerSerialNo }}</div>
              <div>
                <state-label :state="row.workflowState">
                  {{ $t("workOrderStates." + row.workflowState) }}
                </state-label>
                <small v-if="row.pausedAt != null" class="orange">{{
                  $t("text.stop")
                }}</small>
                <a
                  v-if="row.sizeTemplate"
                  class="font10"
                  :href="row.sizeTemplate"
                  target="_blank"
                >
                  {{ $t("orderMes.sizeTemplate") }}
                </a>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="100"
            sortable
          >
            <template v-slot="{ row }">
              {{ row.productNo }}
              <small
                v-if="
                  row.orderCustomerProductNo != null &&
                  row.orderCustomerProductNo != ''
                "
                >({{ row.orderCustomerProductNo }})</small
              >
              <div class="font10">
                {{ row.category }}
                <span v-if="row.productBrand != null">/</span>
                {{ row.productBrand }}
              </div>
              <div class="font10">{{ row.color }} {{ row.size }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="60"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}{{ row.unit }}
              <div v-if="row.receiveQuantity" class="font10">
                {{ $t("action.receive") }}:{{ row.receiveQuantity }}
              </div>
              <div v-if="row.qaQuantity" class="font10">
                {{ $t("action.qa") }}:{{ row.qaQuantity }}
              </div>
              <div v-if="row.shipQuantity" class="font10">
                {{ $t("work.ship") }}:{{ row.shipQuantity }}
              </div>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="handOverAt"
            :title="$t('text.handOverAt')"
            width="170"
            sortable
          >
            <template v-slot="{ row }">
              {{ row.handOverAt }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="handler"
            :title="$t('text.handle')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.handler }}
              <div class="font10">{{ row.handleDepart }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="remark"
            :title="$t('text.remark')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number
                :content="row.remark"
                :number="8"
                type="richText"
              />
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="hangSubmitDoing"
          size="small"
          @click="hangSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="hangDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Util from "@/utils/index.js";
import Hang from "@/api/hang.js";
import WorkOrder from "@/api/workOrder.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtmlLimitNumber,
    DateRange,
  },
  data() {
    return {
      Util: Util,

      narrows: [
        [
          {
            label: this.$t("hang.hangInfo"),
            items: [
              {
                label: this.$t("hangInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("hangInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        createAtStratAt: null,
        createAtEndAt: null,
      },
      sorter: {
        sortBy: "hangs_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "hangs_productNo",
        handOverAt: "hangs_handOverAt",
      },
      //
      currentRowId: null,
      currentRowIdx: null,
      //结束
      hangWorkOrders: [],
      hangDF: false,
      row: null,
      hangObj: {
        handOverAt: null,
        remark: null,
        woIds: [],
      },
      hangSubmitDoing: false,
      selectWorkOrders: [],
    };
  },

  created() {
    const self = this;
  },
  methods: {
    finish(row) {
      const self = this;
      self.row = row;
      self.hangObj.handOverAt = self.row.hangOrder.handOverAt;
      self.hangObj.remark = self.row.remark;
      WorkOrder.findByOrderUuid({ orderUuid: self.row.hangOrder.uuid }).then(
        function (res) {
          if (res.status === 200) {
            self.hangWorkOrders = res.data.filter((r) =>
              ["newly", "processing", "processed"].includes(r.workflowState)
            );
          } else {
            self.sysError();
          }
          self.hangDF = true;
        }
      );
    },
    checkboxChangeEvent({ records }) {
      this.isAllChecked = this.$refs.workOrdersTable.isAllCheckboxChecked();
      this.isIndeterminate = this.$refs.workOrdersTable.isCheckboxIndeterminate();
      this.selectWorkOrders = records;
    },
    changeAllEvent() {
      this.$refs.workOrdersTable.setAllCheckboxRow(this.isAllChecked);
      this.selectWorkOrders = this.$refs.workOrdersTable.getCheckboxRecords();
    },
    hangSubmit() {
      const self = this;
      this.$refs.hangForm.validate((valid) => {
        if (valid) {
          if (!(self.selectWorkOrders.length === self.row.order.quantity)) {
            self.$message({
              message: self.$t("prompt.hangCheckedWorkOrder"),
              type: "warning",
            });
            return;
          }
          self.hangObj.handOverAt =
            Util.formatDate(self.hangObj.handOverAt) + " 00:00:00";
          self.hangObj.woIds = self.selectWorkOrders.map((c) => c.id);
          self.hangSubmitDoing = true;
          Hang.finish(self.row.id, self.hangObj).then(function (res) {
            if (res.status === 200) {
              self.$message({
                message: res.data.message,
                type: "success",
              });
            } else {
              self.sysError();
            }
            self.hangSubmitDoing = false;
            self.hangDF = false;
            self.loadData();
          });
        } else {
          return false;
        }
      });
    },
    //
    dataProvider(params) {
      return Hang.search(params);
    },
  },
};
</script>
